<template>
	<section class="watchlist-banner">
		<div class="banner-inner relative overflow-hidden rounded-3xl">
			<!-- Decorative grid + plus marks -->
			<div class="grid-overlay absolute inset-0 pointer-events-none"></div>

			<div
				class="relative z-10 grid grid-cols-1 lg:grid-cols-2 items-center gap-8 px-6 py-10 sm:px-10 lg:py-12"
			>
				<!-- Left: copy -->
				<div class="text-left">
					<h2
						class="title-font text-3xl lg:text-[2.6rem] font-bold leading-tight text-white mb-4"
					>
						Missing Out on the
						<br class="hidden sm:block" />
						AI Stock Surge?
					</h2>

					<p class="text-lg lg:text-xl text-white leading-relaxed mb-8 max-w-md">
						You're not lazy. You're just not trading with the right system.
					</p>

					<NuxtLink
						:to="ctaUrl"
						class="cta-button group inline-flex items-center gap-2 rounded-xl px-7 py-4 font-bold text-base lg:text-lg transition-all duration-200 hover:scale-[1.02] focus:outline-none focus:ring-2 focus:ring-yellow-300 focus:ring-offset-2 focus:ring-offset-[#1e3a72]"
					>
						<span>Sign me up for FREE trade alerts!</span>
						<svg
							class="transition-transform duration-200 group-hover:translate-x-1"
							width="22"
							height="22"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M14 4.92993L12.5 6.42993L17.0703 11.0002H3V13.0002H17.0703L12.5 17.5706L14 19.0706L21.0703 12.0002L14 4.92993Z"
								fill="currentColor"
							/>
						</svg>
					</NuxtLink>

					<!-- Social proof -->
					<div class="mt-8 flex items-center gap-4">
						<div class="flex -space-x-3">
							<img
								src="/images/tbohen.png"
								alt="Trader"
								class="h-10 w-10 rounded-full border-2 border-[#1e3a72] object-cover"
							/>
							<img
								src="/images/mmonaco.png"
								alt="Trader"
								class="h-10 w-10 rounded-full border-2 border-[#1e3a72] object-cover"
							/>
							<img
								src="/images/btuohey.png"
								alt="Trader"
								class="h-10 w-10 rounded-full border-2 border-[#1e3a72] object-cover"
							/>
						</div>
						<p class="text-sm text-blue-200/80 max-w-xs leading-snug">
							Join 47,000+ traders who've already upgraded their game with XGPT's
							precision AI signals.
						</p>
					</div>
				</div>

				<!-- Right: headshot -->
				<div class="headshot-box relative overflow-hidden rounded-2xl">
					<img
						src="/images/Tim-Sykes-Headshot.webp"
						alt="Tim Sykes"
						class="h-full w-full object-cover object-bottom"
					/>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup>
const ctaUrl = useCampaignUrl(
	"https://traders.timothysykes.com/after-hours/night-tape?utm_medium=ts.com&utm_source=tim&utm_term=web_ads&utm_campaign=oKfY7g"
);
</script>

<style scoped>
.banner-inner {
	background: radial-gradient(
		120% 120% at 20% 30%,
		#274785 0%,
		#1e3a72 45%,
		#173063 100%
	);
	box-shadow: 0 4px 30px 0 rgba(37, 59, 102, 0.25);
}

/* Subtle blueprint grid with faint plus marks */
.grid-overlay {
	background-image: linear-gradient(
			rgba(255, 255, 255, 0.05) 1px,
			transparent 1px
		),
		linear-gradient(90deg, rgba(255, 255, 255, 0.05) 1px, transparent 1px);
	background-size: 84px 84px;
	mask-image: radial-gradient(120% 120% at 50% 50%, #000 60%, transparent 100%);
	-webkit-mask-image: radial-gradient(
		120% 120% at 50% 50%,
		#000 60%,
		transparent 100%
	);
}

.cta-button {
	color: #1e3a72;
	background: linear-gradient(to bottom, #f6c945, #e6b333);
	box-shadow: 0 6px 18px 0 rgba(230, 179, 51, 0.35);
}

.cta-button:hover {
	background: linear-gradient(to bottom, #ffd65a, #f0bb3d);
	box-shadow: 0 8px 22px 0 rgba(230, 179, 51, 0.45);
}

.headshot-box {
	background: linear-gradient(160deg, #d6e6fb 0%, #9fc0ea 100%);
	min-height: 280px;
	aspect-ratio: 4 / 3;
}

@media (min-width: 1024px) {
	.headshot-box {
		min-height: 380px;
		aspect-ratio: auto;
		height: 100%;
	}
}
</style>
